import React from "react";
import Reveal from "../components/Reveal";
import HubSpotFormEmbed from "../components/HubSpotFormEmbed";

const Sponsors = () => {
  return (
    <main>
      {/* HERO */}
      <section className="eco-grad-hero pt-[88px] sm:pt-[100px] pb-16 text-white relative overflow-hidden">
        <div className="absolute -top-40 -right-32 w-[640px] h-[640px] rounded-full bg-[#ff243d]/15 blur-[140px] aurora-pulse" />
        <div
          className="absolute -bottom-32 -left-32 w-[420px] h-[420px] rounded-full bg-[#143DE5]/15 blur-[140px] aurora-pulse"
          style={{ animationDelay: "2s" }}
        />
        <div className="max-w-[1320px] mx-auto px-5 sm:px-6 lg:px-10 relative">
          <Reveal>
            <div className="text-sm tracking-[0.2em] uppercase text-white/60 mb-3">
              Sponsorship
            </div>
            <h1 className="font-display text-[2.25rem] sm:text-5xl md:text-6xl font-semibold leading-tight max-w-3xl">
              Connect and Engage with leaders shaping Asia&apos;s AI future
            </h1>
          </Reveal>
        </div>
      </section>

      {/* ENQUIRY FORM */}
      <section
        id="enquire"
        className="bg-black text-white py-14 md:py-20 scroll-mt-24"
      >
        <div className="max-w-[1320px] mx-auto px-5 sm:px-6 lg:px-10">
          <Reveal>
            <HubSpotFormEmbed
              src="/hubspot-sponsorship-form.html"
              title="Sponsorship enquiry form"
            />
          </Reveal>
        </div>
      </section>
    </main>
  );
};

export default Sponsors;
